const ADMIN_PANEL_BASE = '/itisadminpanel'

const ApplicationLinks = {
  loginLink: () => '/login',
  productsLink: () => '/products',
  aboutUsLink: () => '/about',
  pricingLink: () => '/pricing',
  contactLink: () => '/contact',
  privacyPolicyLink: () => '/privacy-policy',
  shippingPolicyLink: () => '/shipping-policy',
  refundAndCancelationLink: () => '/refund-and-cancelation',
  termsAndConditionsink: () => '/terms-and-conditions',
  onboardingLink: () => '/onboarding',
  maintenanceLink: () => '/status/maintenance',
  selectStoreLink: () => `/select-store`,
  currentAccountLink: () => `/dashboard/current-account`,
  activityLink: () => `/dashboard/activities`,
  customerLink: () => `/management/customers`,
  newQuotationLink: () => `/management/new-quotation`,
  quotationsLink: () => `/management/quotations`,
  agreementsLink: () => `/management/agreements`,
  tableConfigurationsLink: () => `/management/table-configurations`,
  profileDetailLink: () => `/management/profile/details`,
  invoiceTnCLink: () => `/management/tnc`,
  importDataLink: () => `/management/import-data`,
  profileSettingsLink: () => `/management/profile/settings`,
  changePasswordLink: () => `/management/profile/change-password`,
  subscriptionPlansLink: () => `/management/profile/subscription-plans`,
  pendingBillsLink: () => `/management/profile/due_invoices`,
  storeChangeLink: () => `/management/profile/change`,
  stockItemCategoryLink: () => `/stock/item-category`,
  stockTransactionsLink: () => `/stock/stock-transactions`,
  vendorsLink: () => `/stock/vendors`,
  manageTaskLink: () => `/management/tasks`,
  stockItemLink: () => `/stock/items`,
  allBillsLink: () => `/reports/all-bills`,
  saleInvoicesLink: () => `/reports/sale-invoices`,
  paymentHistoryLink: () => `/reports/payment-history`,
  recentBillsLink: () => `/bills/recent-bills`,
  gstr1SummaryLink: () => `/reports/gstr1`,
  billingChartLink: () => `/charts/billing-chart`,
  billsPaymentChartLink: () => `/charts/bills-payment-chart`,
  sitesRentLink: () => `/charts/site-wise-rent`,
  sitesMonthlyRentLink: () => `/charts/site-monthly-rent`,
  allSitesLedgerLink: () => `/charts/billing-summary`,
  ledgerSummaryLink: () => `/charts/ledger-summary`,
  sitesStockSummaryLink: () => `/charts/sites-stock-summary`,

  gstr3bLink: () => `/reports/gstr-3b`,
  paymentSummary: () => `/rrwerrwrrwrwr/asdhhdsdhahfhshdfhhsfshfshfshfhsdf`,
  adminPanelLink: () => ADMIN_PANEL_BASE,
  adminSoftwareInvoicesLink: () =>
    `${ADMIN_PANEL_BASE}/software-invoices`,
  adminSearchStoresLink: () => `${ADMIN_PANEL_BASE}/search-stores`,
  adminReferenceStoresLink: () => `${ADMIN_PANEL_BASE}/reference-stores`,
  adminRecentlySignedupStoresLink: () =>
    `${ADMIN_PANEL_BASE}/recently-signedup-stores`,
  adminSubscriptionReportLink: () =>
    `${ADMIN_PANEL_BASE}/subscription-report`,
  adminExpiringSubscriptionsLink: () =>
    `${ADMIN_PANEL_BASE}/expiring-subscriptions`,

  stockItemCompositeLink: (category_id) => `/stock/items/${category_id}`,
  stockPendingItemLink: (item_id) => `/stock/pending-items/${item_id}`,
  createBillLink: (billId) => `/create-bill/${billId}`,
  slipsLink: (bill_id, customer_id) =>
    `/slips/view-slips/${bill_id}/${customer_id}`,
  slipsByDateLink: (screen_type) => `/slips/by-date/${screen_type}`,
  allChallansLink: (challan_type) => `/more/all-challans/${challan_type}`,
  restoreBackup: () => `/more/restore-backup`,
  staffLink: () => `/staff/my-staff`,
  billsLink: (account_id) => `/bills/monthly-bills/${account_id}`,
  quotationLink: (bill_id) => `/quotation/view-quotation/${bill_id}`,
  contactUsLink: () => `/support/contact`,
  errorPageLink: (code) => `/status/${code}`,
}

export default ApplicationLinks
